import { Vue, Component, Watch } from 'vue-property-decorator';
import Bricks, { BricksInstance } from 'bricks.js';
import _ from 'lodash';
import {
  test,
  getImageUrls,
  getImageUrl,
  getImageInfos,
  getTestJson,
  getImageJson
} from '@/firebase/firebaseStorage';
import { ImageInfo } from '@/interfaces/ImageInfo';

@Component({})
export default class ImageList extends Vue {
  private bricksInstance!: BricksInstance;

  private loadedImageCount = 0;

  private imageInfos: ImageInfo[] = [];

  private isGoodBad: 'good' | 'bad' = 'good';

  private resizeEventListener = _.debounce(
    this.resizeEventListenerInnerFunction,
    250
  );

  private resizeEventListenerInnerFunction() {
    if (this.bricksInstance) {
      this.bricksInstance.pack();
    }
  }

  @Watch('isGoodBad')
  private async isGoodBadChanged(isGoodBad: 'good' | 'bad') {
    this.loadedImageCount = 0;
    if (isGoodBad === 'good') {
      this.imageInfos = await getImageInfos('good/thumb');
    } else {
      this.imageInfos = await getImageInfos('bad/thumb');
    }
  }

  private async mounted() {
    this.imageInfos = await getImageInfos('good/thumb');
    const testUrl = await getImageUrl('good/thumb', 'a0016-jmac_MG_0795.jpg');
    console.log('testUrl', testUrl);

    const sizes = [
      { mq: '0', columns: 1, gutter: 15 },
      { mq: `${400 * 2 + 30 * 2}px`, columns: 2, gutter: 20 },
      { mq: `${400 * 3 + 30 * 3}px`, columns: 3, gutter: 25 },
      { mq: `${400 * 4 + 30 * 4}px`, columns: 4, gutter: 30 },
      { mq: `${400 * 5 + 30 * 5}px`, columns: 5, gutter: 30 }
    ];

    // create an instance
    this.bricksInstance = Bricks({
      container: '.selector',
      packed: 'data-packed', // 이게 뭔지는 파악해야 함
      sizes
    });
    this.bricksInstance.pack();

    window.addEventListener('resize', this.resizeEventListener);
  }

  private updated() {
    // console.log('updated');
    // this.bricksInstance.update(); // 새로 생긴 element를 pack()
  }

  private destroyed() {
    window.removeEventListener('resize', this.resizeEventListener);
  }

  private toFilename(url) {
    console.log(url);
    return url
      .split('?')[0]
      .split('/')
      .slice(-1)[0];
  }

  private imageLoaded(i: number) {
    this.loadedImageCount += 1;

    if (this.loadedImageCount === this.imageInfos.length) {
      if (this.bricksInstance) {
        this.bricksInstance.pack(); // 전체 elements를 pack()
      }
    }
  }

  private addBrick() {
    // this.imageInfos.push('/images/19983881105_e93c2d8279_b.jpg');
  }
}
